import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#fff",
      "data-name": "Raggruppa 580"
    }, [
      _createElementVNode("path", {
        d: "M12 0a12 12 0 1 0 12 12A12.035 12.035 0 0 0 12 0Zm0 23a11 11 0 1 1 11-11 10.968 10.968 0 0 1-11 11Z",
        "data-name": "Tracciato 540"
      }),
      _createElementVNode("path", {
        d: "M11.1 7.9a1 1 0 0 0-1.6.8v6.6a1 1 0 0 0 1.6.8l4.7-3.3a.936.936 0 0 0 0-1.6l-4.7-3.3Z",
        "data-name": "Tracciato 541"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "play"}) } }